import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, switchMap, take, tap } from 'rxjs';

import { inject } from '@angular/core';
import { AuthenticationService } from '@core/services';
import { environment } from '@env/environment';

export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const authService = inject(AuthenticationService);

  return authService.authToken$.pipe(
    take(1),
    switchMap(authToken => {
      if (authToken && !req.url.includes(environment.ApiLoginUrl)) {
        const authReq = req.clone({
          headers: req.headers.set('Authorization', `Bearer ${authToken}`),
        });
        return next(authReq);
      }
      return next(req);
    })
  );
};

export const tokenRenewInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const authService = inject(AuthenticationService);
  return next(req).pipe(
    tap(event => {
      if (!(event instanceof HttpResponse)) {
        return;
      }
      const newToken = event.headers.get('X-Renewed-Token');

      if (newToken) {
        authService.updateToken(newToken);
      }
    })
  );
};
